import script from "./ShippingDetailsLocationV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingDetailsLocationV2.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingDetailsLocationV2.vue?vue&type=style&index=0&id=2f744992&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f744992"]])

export default __exports__